import { Service } from '@angular/core';

import { isSet } from '@shared/utils';
import { PHONE_PATTERN } from '../validators/phone.validator';

@Service()
export class ValidatorService {
  validateEmail = (email: unknown) => {
    if (typeof email !== 'string') {
      return false;
    }

    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      return false;
    }

    const emailRegex =
      // eslint-disable-next-line security/detect-unsafe-regex -- every repetition is delimited by a literal "." that the repeated classes exclude, so matching is linear (benchmarked with 320k-char inputs)
      /^(?:"[^"\r\n]+"|[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|\[(?:25[0-5]|2[0-4]\d|1?\d?\d)(?:\.(?:25[0-5]|2[0-4]\d|1?\d?\d)){3}\])$/;

    return emailRegex.test(trimmedEmail);
  };

  validateCommunityName = (community: string) => /^[^<>]+$/.test(community);

  validPhone = (phone?: Nullable<string>, required?: boolean) => {
    if (phone && isSet(phone)) {
      return PHONE_PATTERN.test(phone.trim());
    }

    return !required;
  };
}
